import { ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
// import { FCM } from '@awesome-cordova-plugins/fcm/ngx';


import { GlobalErrorHandler } from './services/error-handler.service';
import { ErrorHandlerInterceptor } from './interceptors/error-handler.interceptor';
import { AuthService } from './services/auth.service';
import { PlatformService } from './services/platform.service';
import { AuthGuard } from './guards/auth.guard';
import { UserService } from './services/user.service';
import { AnonymousGuard } from './guards/anonymous.guard';
import { UserGuard } from './guards/user.guard';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HelperService } from './services/helper.service';
import { OfflineGuard } from './guards/offline.guard';
import { StorageService } from './services/offline-storage.service';
import { DownloadFileService } from './services/download-file.service';
import { PushService } from './services/push.service';
import { AsperaService } from './services/aspera.service';

@NgModule({
  imports: [
    BrowserAnimationsModule,
  ],
  exports: [],
  declarations: [],
  providers: [
    StorageService,
    PlatformService,
    UserService,
    DownloadFileService,
    // PushService,
    HelperService,
    AuthService,
    AsperaService,
    AuthGuard,
    AnonymousGuard,
    UserGuard,
    OfflineGuard,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    // FirebaseX,
    // FCM,
  ],
})
export class CoreModule {}
